module.exports = __webpack_public_path__ + "static/media/Constitution Amended June 2017.64a1143c.pdf";